<template>
  <v-app>
    <div id="app" v-if="callQuery">
      <router-view></router-view>
  </div>
  </v-app>
</template>

<script>
import { newToken } from './vue-apollo'
export default {
  name: 'App',
  data () {
    return {
      newToken,
      callQuery: false
    }
  },
  created: function () {
    this.userTokenAvailable()
    this.smartFavicon()
  },
  methods: {
    smartFavicon () {
      let link = document.querySelector("link[rel~='icon']")
      if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.getElementsByTagName('head')[0].appendChild(link)
      }
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        link.href = 'favicon_dark.ico'
      } else {
        link.href = 'favicon.ico'
      }
    },
    userTokenAvailable () {
      let token
      if (Promise.resolve(newToken) === newToken) {
        newToken.then(data => {
          token = data
        })
      } else {
        token = newToken
      }
      setTimeout(() => {
        // const token = window.localStorage.getItem('token')
        if (token) {
          this.callQuery = true
        } else {
          setTimeout(() => {
            this.userTokenAvailable()
          }, 1)
        }
      }, 1)
    }
  },
  components: {
    // RunnersList,
    // RaceName,
    // TestQuery
  }
}
</script>

<style>
html {
  scroll-behavior: smooth;
}
h1 {
  margin: 0;
}
.logo {
  float: left;
}
body {
  background-color: rgb(255,255,255);
  /*position: relative;*/
  top: 0;
  left: 0;
  margin-top: 0;
  margin-left: auto;
  margin-right: auto;
}
#app {
  font-family: Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  box-shadow: 0px 2px 8px 1px lightgray;
}
</style>
